module.exports = __WEBPACK_EXTERNAL_MODULE_6__;


//////////////////
// WEBPACK FOOTER
// external {"root":["ng","common"],"commonjs":"@angular/common","commonjs2":"@angular/common","amd":"@angular/common"}
// module id = 6
// module chunks = 0